import styled from 'styled-components';
import tw from 'twin.macro';





export const ExtraHeaderUIContainer = styled.div`
  ${tw`flex justify-between items-center w-full mb-2`};
  @media (min-width: 769px) {
    margin-top: 6px;
  }
  @media (max-width: 768px) {
    ${tw`mt-2`}
  }
`;

export const ExtraHeaderUITitleContainer = styled.div`
  ${tw`flex flex-col`}
`;

export const ExtraHeaderUITitle = styled.span`
  ${tw`text-lg leading-7 font-semibold font-inter text-lightblueGray800`}
`;

export const ScholarshipImage = styled.img`
  width: 86px;
  height: 65px;

  @media (max-width: 768px) {
    width: 79px;
    height: 59px;
  }
`;

export const WebinarRegistrationFormContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;
  border-radius: 8px;
  padding: 12px;
  background-color: #dbeafe;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  @media (max-width: 1199px) {
    display: none;
  }
`;

export const WebinarRegistrationFormTitle = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  vertical-align: middle;
  color: #1e293b;
`;

export const WebinarRegistrationFormDescription = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.2px;
  vertical-align: middle;
  color: #1e293b;
  max-width: 100%;

  @media (max-width: 768px) {
    max-width: 252px;
  }
`;

export const GiftIcon = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0;
  height: 50px;

  @media (max-width: 768px) {
    height: 40px;
  }
`;
